import { useQueryClient } from "@tanstack/react-query";

import { organizationServiceQueries } from "../queries";
import AsyncOptionsSelect, {
  monospaceSelectStyles,
} from "../select/AsyncOptionsSelect";
import { fetchOrganizationServicesCallback } from "../types";

export type OrganizationServiceSelectProps = {
  // The selected service's name — what an agent config's
  // service_config.service_name references.
  value: string | null;
  // Restrict the options to one service type (e.g. "llm").
  serviceType?: string | null;
  fetchOrganizationServices: fetchOrganizationServicesCallback;
  onChange: (e: { target: { value: string } }) => void;
  placeholder?: string;
  inputId?: string;
};

const OrganizationServiceSelect = ({
  value,
  serviceType,
  fetchOrganizationServices,
  onChange,
  placeholder,
  inputId,
}: OrganizationServiceSelectProps) => {
  const queryClient = useQueryClient();

  const fetchOptions = async () => {
    const services = await queryClient.fetchQuery({
      queryKey: organizationServiceQueries.all(),
      queryFn: () => fetchOrganizationServices(),
      staleTime: Infinity,
    });
    return services
      .filter((service) =>
        serviceType ? service.service_type === serviceType : true
      )
      .map((service) => ({ value: service.name, label: service.name }));
  };

  return (
    <AsyncOptionsSelect
      inputId={inputId}
      value={value}
      fetchOptions={fetchOptions}
      onChange={onChange}
      placeholder={placeholder}
      styles={monospaceSelectStyles}
      menuPortalToBody
    />
  );
};

export default OrganizationServiceSelect;
